import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/tel/1.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-53ed68d9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "personalDetail"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "box flex align-center justify-between"
};
var _hoisted_4 = {
  class: "flex flex-column justify-center h-100"
};
var _hoisted_5 = {
  class: "t"
};
var _hoisted_6 = {
  class: "d"
};
var _hoisted_7 = {
  class: "r"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title",
    style: {
      "font-size": "12px"
    }
  }, "基本信息", -1);
});
var _hoisted_9 = {
  class: "info"
};
var _hoisted_10 = {
  class: "row"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "手机号：", -1);
});
var _hoisted_12 = {
  class: "value blue"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "40px",
      "height": "40px"
    }
  }, null, -1);
});
var _hoisted_14 = [_hoisted_13];
var _hoisted_15 = {
  class: "row"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "部门：", -1);
});
var _hoisted_17 = {
  class: "value"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title",
    style: {
      "font-size": "12px"
    }
  }, "岗位职责", -1);
});
var _hoisted_19 = ["innerHTML"];
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title",
    style: {
      "font-size": "12px"
    }
  }, "考勤信息", -1);
});
var _hoisted_21 = {
  class: "infobox"
};
var _hoisted_22 = {
  class: "item"
};
var _hoisted_23 = {
  class: "num"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "应出勤", -1);
});
var _hoisted_25 = {
  class: "item"
};
var _hoisted_26 = {
  class: "num"
};
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "实际出勤", -1);
});
var _hoisted_28 = {
  class: "item"
};
var _hoisted_29 = {
  class: "num"
};
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "未出勤", -1);
});
var _hoisted_31 = {
  class: "item"
};
var _hoisted_32 = {
  class: "num"
};
var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "迟到", -1);
});
var _hoisted_34 = {
  class: "item"
};
var _hoisted_35 = {
  class: "num"
};
var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "旷工", -1);
});
var _hoisted_37 = {
  class: "item"
};
var _hoisted_38 = {
  class: "num"
};
var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "漏签", -1);
});
var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title",
    style: {
      "font-size": "12px"
    }
  }, "领用信息", -1);
});
var _hoisted_41 = {
  class: "infobox"
};
var _hoisted_42 = {
  class: "item"
};
var _hoisted_43 = {
  class: "num"
};
var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "本月领用次数", -1);
});
var _hoisted_45 = {
  class: "item"
};
var _hoisted_46 = {
  class: "num"
};
var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "本月领用金额/元", -1);
});
var _hoisted_48 = {
  class: "item"
};
var _hoisted_49 = {
  class: "num"
};
var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txt"
  }, "本年领用金额/万", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.user_name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.company), 1)]), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.user_name), 1)]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.param.mobile), 1), _createElementVNode("div", {
    class: "ml-auto",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.test && _ctx.test.apply(_ctx, arguments);
    })
  }, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.data.name), 1)])]), _hoisted_18, _createElementVNode("div", {
    class: "info",
    innerHTML: _ctx.emptyStringFormat(_ctx.data.responsibility)
  }, null, 8, _hoisted_19), _hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.data1.workDays), 1), _hoisted_24]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.data1.realWorkDays), 1), _hoisted_27]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.data1.absentFromWork), 1), _hoisted_30]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.data1.beLate), 1), _hoisted_33]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.data1.leaveDays), 1), _hoisted_36]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.data1.noSign), 1), _hoisted_39])]), _hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.data.monthCount), 1), _hoisted_44]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.data.monthMoney), 1), _hoisted_47]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.data.yearMoney), 1), _hoisted_50])])])]);
}